import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';

var GroupSelector = /*#__PURE__*/function (_Component) {
  _inherits(GroupSelector, _Component);

  var _super = _createSuper(GroupSelector);

  function GroupSelector(props) {
    var _this;

    _classCallCheck(this, GroupSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onGroupSelect", function (event, id) {
      if (_this.props.required) {
        if (event.target != null) {
          if (event.target.value === '' || event.target.value === '0') {
            _this.setState({
              error: _this.props.translate('field-needs-input')
            });

            return;
          } else {
            _this.setState({
              error: ''
            });
          }
        }
      }

      if (event) {
        if (event.target != null) {
          if (_this.props.onChange) {
            var group = _this.props.groups.find(function (x) {
              return x.id == event.target.value;
            });

            if (group) {
              _this.props.onChange(event.target.value, group);
            } else {
              _this.props.onChange(event.target.value);
            }
          }
        }
      }

      if (id && id != '0') {
        if (_this.props.onChange) {
          _this.props.onChange(id);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "groupOptions", function (groups) {
      return groups.map(function (group, i) {
        if (group.classroomUrl == null || group.classroomUrl == '' && _this.props.sectionId == null) {
          return /*#__PURE__*/React.createElement("option", {
            key: "group-select-".concat(i),
            disabled: true,
            value: group.id
          }, "".concat(group.title, " (").concat(_this.props.translate('Workspace missing'), ")"));
        }

        if (group.currentUserRole == 'OWNER') {
          if (_this.props.sectionId == null || _this.props.cloneView) {
            return /*#__PURE__*/React.createElement("option", {
              key: "group-select-".concat(i),
              value: group.id
            }, group.title);
          }

          if (_this.props.sectionId == group.id) {
            return /*#__PURE__*/React.createElement("option", {
              key: "group-select-".concat(i),
              value: group.id
            }, group.title);
          }

          return /*#__PURE__*/React.createElement("option", {
            key: "group-select-".concat(i),
            value: group.id
          }, group.title);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var sectionId = _this.props.sectionId;

      if (sectionId != null && sectionId != 0) {
        var find = _this.props.groups.find(function (t) {
          return t.id == sectionId;
        });

        if (find == null) {
          _this.setState({
            error: _this.props.translate('field-needs-input')
          });

          _this.props.onChange(0);
        }
      }
    });

    _this.state = {
      error: ''
    };
    return _this;
  }

  _createClass(GroupSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          groups = _this$props.groups,
          sectionId = _this$props.sectionId,
          disabled = _this$props.disabled,
          required = _this$props.required;
      var error = this.state.error;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, this.props.translate('section'), required ? '*' : null), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        name: "grup",
        id: "groups-selector",
        value: sectionId ? sectionId : '',
        onChange: this.onGroupSelect,
        disabled: disabled
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate('select-an-alternative')), this.groupOptions(groups)), required && error !== '' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, error)) : null));
    }
  }]);

  return GroupSelector;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    groups: state.sections.educationGroups
  };
}

export default connect(mapStateToProps)(GroupSelector);